const getInquiringProviderUserFirstName = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business
    && business['Company Info']
    && business['Company Info']['Signer First Name']) {
    return business['Company Info']['Signer First Name'];
  }
  return null;
};

export default getInquiringProviderUserFirstName;



// WEBPACK FOOTER //
// ./src/utils/print/getInquiringProviderUserFirstName.js